// extracted by mini-css-extract-plugin
module.exports = {"container-form":"OpenpayFormDetails_container-form__RiQCq","container-button-send":"OpenpayFormDetails_container-button-send__2paw5","button":"OpenpayFormDetails_button__Uf8An"};